<template>
    <div v-if="ready">
        <v-divider class="grey darken-4"/>
        <div v-for="(inquiry, index) in inquires" :key="index">
            <div class="px-8px py-12px px-md-10px py-md-16px">
                <v-row no-gutters>
                    <v-col cols="auto">
                        <v-avatar color="primary" size="32" class="mr-10px"><strong class="font-size-14 white--text mt-n2px">Q</strong></v-avatar>
                    </v-col>
                    <v-col cols="auto">
                        <v-row no-gutters align="center" class="font-size-14 font-size-md-16">
                            <v-col cols="auto">
                                <span>{{ inquiry.writer.name }}</span>
                            </v-col>
                            <v-col cols="auto" class="d-flex"><v-divider vertical class="grey lighten-1 mx-8px" style="height:12px;" /></v-col>
                            <v-col cols="auto">
                                <span>{{ $dayjs(inquiry.createdAt).format("YYYY-MM-DD") }}</span>
                            </v-col>
                        </v-row>
                        <div class="mt-10px">
                            <strong class="font-weight-medium line-height-12">{{ inquiry.content }}</strong>
                            <div v-if="inquiry._member == payload?._user" class="mt-16px">
                                <div class="v-btn--group--x-small">
                                    <v-btn @click="edit(inquiry)" x-small color="secondary">수정</v-btn>
                                    <v-btn @click="remove(inquiry)" x-small outlined class="white" style="border-color:#9e9e9e!important;"><span class="grey--text text--darken-3">삭제</span></v-btn>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>

            <template v-if="inquiry.answer">
                <div class="pa-12px py-md-14px grey lighten-4">
                    <v-row no-gutters>
                        <v-col cols="auto">
                            <v-avatar color="secondary" size="32" class="mb-6px mr-10px mb-md-0px"><strong class="font-size-14 white--text mt-n2px">A</strong></v-avatar>
                        </v-col>
                        <v-col cols="auto">
                            <v-row no-gutters align="center" class="font-size-14 font-size-md-16">
                                <v-col cols="auto">
                                    <span>{{ inquiry.respondent?.name }}</span>
                                </v-col>
                                <v-col cols="auto" class="d-flex"><v-divider vertical class="grey lighten-1 mx-8px" style="height:12px;" /></v-col>
                                <v-col cols="auto">
                                    <span>{{ $dayjs(inquiry.answeredAt).format("YYYY-MM-DD") }}</span>
                                </v-col>
                            </v-row>
                            <div class="font-size-14 font-size-md-16 mt-10px">
                                <p v-html="inquiry.answer?.replace?.(/\n/g, '<br>')"></p>
                            </div>
                        </v-col>
                    </v-row>
                </div>
                <v-divider/>
            </template>
        </div>
        <v-divider />

        <div class="mt-20px mt-md-30px">
            <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(false)"/>
        </div>

        <div class="mt-10px mt-md-20px">
            <v-row class="row--x-small">
                <v-spacer/>
                <v-col cols="auto">
                    <v-btn @click="show = true" large color="primary">상품문의</v-btn>
                </v-col>
            </v-row>
        </div>

        <v-dialog v-model="show" max-width="500">
            <v-card class="v-card--dialog v-card--dialog--sm">
                <div class="v-card--dialog__head">
                    <h3 class="tit tit--xs">상품문의</h3>
                    <v-btn fab color="transparent" @click="show = false" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
                </div>
                <div class="v-card--dialog__body">
                    <div>
                        <v-textarea v-model="inquiry.content" placeholder="문의내용을 입력해주세요" persistent-placeholder outlined hide-details rows="8" />
                    </div>
                </div>
                <div class="v-card--dialog__foot">
                    <v-row class="row--x-small">
                        <v-spacer></v-spacer>
                        <v-col cols="auto">
                            <v-btn @click="save" color="primary">등록</v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
        </v-dialog>

        <login-dialog ref="loginDialog" />
    </div>
</template>
<script>
import api from "@/api";
import { mdiHeadset } from "@mdi/js";
import LoginDialog from "@/components/client/login/login-dialog.vue";
export default {
    components: {
        LoginDialog
    },
    props: {
        product: Object
    },
    data(){
        return {
            mdiHeadset,
            ready: false,

            page: 1,
            pageCount: 0,
            limit: 5,

            inquires: [],
            inquiresHeaders: [
                { text: "문의내용", value: "content" },
                { text: "작성자", value: "writer", align: "center", width: 100 },
                { text: "문의일자", value: "createdAt", align: "center", width: 180 },
                { text: "-", value: "actions", width: 80 },
            ],

            show: false,

            inquiry: null
        }
    },
    mounted(){
        this.search();
    },
    methods: {
        async search(){
            let { summary, inquires } = await api.v1.shop.products.inquires.gets(this.product._id, {
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                }
            });
            this.inquires = inquires;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);

            this.inquiry = {
                _product: this.product._id,
                content: null,
            }

            this.ready = true;
        },

        async login(){
            return new Promise((resolve, reject) => {
                if(this.logon) resolve();
                else{
                    this.$refs.loginDialog.$off();
                    this.$refs.loginDialog.$on("login", _ => resolve());
                    this.$refs.loginDialog.$on("cancel", _ => reject());
                    this.$refs.loginDialog.open();
                }
            });
        },

        edit(inquiry){
            this.inquiry = { ...inquiry };
            this.show = true;
        },

        validate(){
            try{
                if(!this.inquiry.content) throw new Error("상품문의 내용을 작성해주세요");
                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },

        async save(){
            if(this.validate() && await this.$confirm("상품문의를 등록하시겠습니까?")){
                this.login().then(async () => {
                    this.inquiry._id ? await api.v1.shop.products.inquires.put(this.product._id, this.inquiry) : await api.v1.shop.products.inquires.post(this.product._id, this.inquiry);
                    alert("상품문의가 등록되었습니다");
                    this.show = false;
                    this.search();
                });
            }
        },

        async remove(inquiry){
            if(await this.$confirm("상품문의를 삭제하시겠습니까?")){
                await api.v1.shop.products.inquires.delete(this.product._id, inquiry);
                alert("상품문의가 삭제되었습니다");
                this.search();
            }
        }

    },
    computed: {
        logon(){ return !!this.$store.state.accessToken },
        payload(){ return this.$store.state.payload; }
    }
}
</script>